import { Controller } from "@hotwired/stimulus";
import { isSwalConfirmed } from "../../utils/misc";
import { patchAjaxRequest } from "../../utils/http_utils";
import { swal } from "../../components/init_sweet_alert";

export default class extends Controller {
  static targets = ["step", "helpNeededStep", "successStep"];
  static values = {
    todoId: Number,
  };

  previousStep(event) {
    const { previousStep } = event.params;

    this._updateStep(previousStep);
  }

  nextStep(event) {
    const { nextStep } = event.params;

    this._updateStep(nextStep);
  }

  showHelpNeededStep() {
    this.displayedStepBeforeHelp = this._currentStep();

    this._updateCurrentStepDisplay(this.displayedStepBeforeHelp, this.helpNeededStepTarget);
  }

  exitHelpNeededStep() {
    this._updateCurrentStepDisplay(this.helpNeededStepTarget, this.displayedStepBeforeHelp);
  }

  _saveStep(nextStepId) {
    const { saveStepUrl } = this.element.dataset;

    patchAjaxRequest(saveStepUrl, { step: nextStepId });
  }

  confirmDelegation(e) {
    const form = e.currentTarget.form;
    swal({
      title: "Confirmez-vous avoir délégué vos formalités à Acasi Accounting ?",
      buttons: { non: true, oui: true },
      className: "custom-swal-modal",
    }).then((value) => {
      if (isSwalConfirmed(value)) {
        Rails.fire(form, "submit");
      }
    });
  }

  resolveTodo() {
    const todoCard = document.querySelector(`[data-todo-id='${this.todoIdValue}']`);
    todoCard.dispatchEvent(new CustomEvent("todo:done"));

    this._updateCurrentStepDisplay(this._currentStep(), this.successStepTarget);

    this._closeSidePanel();
  }

  _updateStep(stepId) {
    const currentStep = this._currentStep();
    const nextStep = this._stepFor(stepId);

    this._saveStep(nextStep.dataset.stepId);

    this._updateCurrentStepDisplay(currentStep, nextStep);
  }

  _updateCurrentStepDisplay(currentStep, nextStep) {
    currentStep.classList.remove("current");
    nextStep.classList.add("current");
  }

  _closeSidePanel() {
    setTimeout(() => {
      document.dispatchEvent(new CustomEvent("sidePanel:close"));
    }, 3000);
  }

  _stepFor(stepId) {
    return this.stepTargets.find((step) => step.dataset.stepId === stepId);
  }

  _currentStep() {
    return this.stepTargets.find((step) => step.classList.contains("current"));
  }
}
